import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'

// import components
import Header from './../../shared/components/Header'
import Portal from './../../shared/components/Portal'
import Confirm from './../../shared/components/Confirm'

// import styles
import './messages.scss'

// Utils
import { renderFullDate } from '../../utils/time'

// Actions
import { getMessageChain, getMessageCompany, deleteMessage } from './../../actions/messages'

// Utils
import { translation } from '../../utils/helpers'
import { hasSubscriptionPermission, hasAccess } from '../../utils/auth'

import TableRow from '../../shared/elements/tableRow'
import TableContainer from '../../shared/elements/tableContainer'
import RemoveButton from '../../shared/elements/removeButton'
import Button from '../../shared/elements/button'
import Inline from '../../shared/elements/inline'

class Messages extends Component {

  constructor (props) {
    super(props)
    this.state = {
      Messages: [],
      delete: {
        type: false,
        id: 0
      },
      IsMobile: false
    }
    this.handleResize = this.handleResize.bind(this)
    this.deleteMessage = this.deleteMessage.bind(this)
    this.deleteMshowDeletePortalessage = this.showDeletePortal.bind(this)
    this.headerButtonsRight = this.headerButtonsRight.bind(this)
    this.getMessagesChain = this.getMessagesChain.bind(this)
    this.getMessagesCompany = this.getMessagesCompany.bind(this)
    this.onConfirm = this.onConfirm.bind(this)
  }

  componentDidMount () {
    if (Number(this.props.auth.user.ShopId) === 0) {
      this.getMessagesChain(this.props.auth.user.ChainId)
    } else {
      this.getMessagesCompany(this.props.auth.user.ShopId)
    }
    this.setState({
      IsMobile: window.outerWidth < 535
    })

    window.addEventListener('resize', this.handleResize)
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.handleResize)
  }

  handleResize () {
    const IsMobile = window.outerWidth < 535
    if (IsMobile !== this.state.IsMobile) {
      this.setState({
        IsMobile
      })
    }
  }

  deleteMessage (Id) {
    this.setState({
      delete: {
        type: true,
        id: Id
      }
    })
  }

  showDeletePortal () {
    // console.log(this.state.delete)
    if (this.state.delete.type === true) {
      return (
        <Portal className='deleteModal' onPortalClose={this.onPortalClose.bind(this, 'confirm')}>
          <Confirm confirm={this.onConfirm} notConfirm={this.onPortalClose.bind(this, 'confirm')} />
        </Portal>
      )
    }
  }

  onConfirm () {
    var DeleteId = Number(this.state.delete.id)
    if (DeleteId > 0) {
      this.props.deleteMessage(DeleteId).then((res) => {
        // Toastr
        // window.toastr.success(translation('1886'), translation('13424'))
        if (Number(this.props.auth.user.ShopId) === 0) {
          this.getMessagesChain(this.props.auth.user.ChainId)
        } else {
          this.getMessagesCompany(this.props.auth.user.ShopId)
        }
      }, () => {
        console.log('err')
        // Toastr
        window.toastr.error(translation('1885'), translation('216'))
      })
      this.onPortalClose('confirm')
    }
  }

  onPortalClose (type) {
    this.setState({
      delete: {
        type: false,
        id: 0
      }
    })
  }

  headerButtonsRight () {
    return (
      <div>
        <Button spacing={0} size='m' ariaLabel={translation('2047')} labelText={translation(1797)} onClick={() => { this.props.router.push('/messages/0') }} />
      </div>
    )
  }

  getMessagesChain (id) {
    this.props.getMessageChain(id).then((res) => {
      this.setState({
        Messages: res.data
      })
    }, () => {
      console.log('err')
    })
  }

  getMessagesCompany (id) {
    this.props.getMessageCompany(id).then((res) => {
      this.setState({
        Messages: res.data
      })
    }, () => {
      console.log('err')
    })
  }

  render () {
    if (!hasSubscriptionPermission(this.props.auth, 30)) return null
    let isChain = hasAccess([2], this.props.auth.user.UserType)
    const messageList = (val, key) => {
      let messagesLink = '/messages/' + val.Id

      let fromChain = val.CompanyId === 0 && !isChain
      if (this.state.IsMobile === false) {
        return (
          <TableRow key={key}>
            <Link to={messagesLink}>{renderFullDate(val.CreationDate)}</Link>
            <Link to={messagesLink}>{renderFullDate(val.StartDate)}</Link>
            <Link to={messagesLink}>{renderFullDate(val.ExpireDate)}</Link>
            <Link to={messagesLink}>{val.Title}</Link>
            {!fromChain ? <RemoveButton bin size='m' onClick={this.deleteMessage.bind(this, val.Id)} /> : <div />}
          </TableRow>
        )
      }

      return (
        <Link to={messagesLink} key={key}>
          <Inline fillChildNum={[0]} block>
            <div>
              <div>{val.Title}</div>
              <div>{translation('1490') + ': '}{renderFullDate(val.StartDate)}</div>
              <div>{translation('1245') + ': '}{renderFullDate(val.ExpireDate)}</div>
            </div>
            {!fromChain ? <RemoveButton bin size='m' onClick={this.deleteMessage.bind(this, val.Id)} /> : <div />}
          </Inline>
        </Link>
      )
    }
    return (
      <div className='messages__screen'>
        <Header router={this.props.router} renderRight={this.headerButtonsRight} />
        {this.showDeletePortal()}
        <TableContainer>
          {!this.state.IsMobile && (
            <TableRow header>
              <span>{translation('13387')}</span>
              <span>{translation('1490')}</span>
              <span>{translation('1245')}</span>
              <span>{translation('1229')}</span>
              <span />
            </TableRow>
          )}
          {this.state.Messages.map(messageList)}
        </TableContainer>
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    employees: state.common.employees
  }
}

export default connect(mapStateToProps, {
  getMessageChain,
  getMessageCompany,
  deleteMessage
})(Messages)



// WEBPACK FOOTER //
// ./src/app/pages/Messages/index.js